import Vue from "vue";
import { AclInstaller, AclCreate, AclRule } from "vue-acl";
import router from "@/router";

Vue.use(AclInstaller);

let initialRole = "student";

const userInfo = JSON.parse(localStorage.getItem("userInfo"));
if (userInfo && userInfo.role) {
  initialRole = userInfo.role.name;

  if (
    (initialRole === "EC" || initialRole === "SM") &&
    userInfo.position_label === "Manager"
  ) {
    initialRole += userInfo.position_label;
  }
}

let userRoles = new AclRule("ECManager").or("SMManager");
let roles = localStorage.getItem("roles");
if (roles) {
  JSON.parse(localStorage.getItem("roles")).map((role) => userRoles.or(role));
}

export default new AclCreate({
  initial: initialRole,
  notfound: "/login",
  router,
  acceptLocalRules: true,
  globalRules: {
    Admin: new AclRule("admin").generate(),
    Student: new AclRule("student").generate(),
    Teacher: new AclRule("teacher").generate(),
    EC: new AclRule("EC").or("ECManager").generate(),
    ECManager: new AclRule("ECManager").generate(),
    SM: new AclRule("SM").or("SMManager").generate(),
    SMManager: new AclRule("SMManager").generate(),
    Operation: new AclRule("operation").generate(),
    Accountant: new AclRule("accountant").generate(),
    OperationsRole: new AclRule("admin")
      .or("SM")
      .or("SMManager")
      .or("EC")
      .or("ECManager")
      .or("teacher"),
    AdminOrEC: new AclRule("admin").or("EC").or("ECManager"),
    AdminOrECorTeacher: new AclRule("admin")
      .or("EC")
      .or("ECManager")
      .or("teacher"),
    User: new AclRule("admin")
      .or("student")
      .or("teacher")
      .or("EC")
      .or("ECManager")
      .or("SM")
      .or("SMManager")
      .or("accountant")
      .or("operation")
      .generate(),

    UserRoles: userRoles.generate(),
  },
});
